import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import resolveReference from './resolveReference';

/* eslint-disable import/prefer-default-export */
export const walkSchemaChildren = (
  schema: OpenAPI.SchemaObject | OpenAPI.ReferenceObject,
  document: OpenAPI.Document,
  visit: (fieldName: string, schema: OpenAPI.SchemaObject) => void,
  visited: Set<string> = new Set(),
): void => {
  const schemaKey = JSON.stringify(schema);
  if (visited.has(schemaKey)) {
    return;
  }
  visited.add(schemaKey);

  if ('$ref' in schema) {
    const resolvedSchema = resolveReference(document, schema, 'schemas');
    if (resolvedSchema) {
      walkSchemaChildren(resolvedSchema, document, visit, visited);
    }
    return;
  }

  // Recursively walk through all child schemas
  if (schema.not !== undefined) {
    walkSchemaChildren(schema.not, document, visit, visited);
  }

  if (schema.allOf !== undefined) {
    schema.allOf.forEach((childSchema) => {
      walkSchemaChildren(childSchema, document, visit, visited);
    });
  }

  if (schema.oneOf !== undefined) {
    schema.oneOf.forEach((childSchema) => {
      walkSchemaChildren(childSchema, document, visit, visited);
    });
  }

  if (schema.anyOf !== undefined) {
    schema.anyOf.forEach((childSchema) => {
      walkSchemaChildren(childSchema, document, visit, visited);
    });
  }

  if ('items' in schema && schema.items !== undefined) {
    walkSchemaChildren(schema.items, document, visit, visited);
  }

  if (schema.properties) {
    Object.entries(schema.properties).forEach(([fieldName, property]) => {
      if ('$ref' in property) {
        const resolvedSchema = resolveReference(document, property, 'schemas');
        if (resolvedSchema) {
          visit(fieldName, resolvedSchema);
          walkSchemaChildren(resolvedSchema, document, visit, visited);
        }
      } else {
        visit(fieldName, property);
        walkSchemaChildren(property, document, visit, visited);
      }
    });
  }

  if (
    schema.additionalProperties !== undefined &&
    typeof schema.additionalProperties !== 'boolean'
  ) {
    walkSchemaChildren(schema.additionalProperties, document, visit, visited);
  }
};
